import { render, staticRenderFns } from "./fileview.vue?vue&type=template&id=1fa69526&scoped=true&"
import script from "./fileview.vue?vue&type=script&lang=js&"
export * from "./fileview.vue?vue&type=script&lang=js&"
import style0 from "./fileview.vue?vue&type=style&index=0&id=1fa69526&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa69526",
  null
  
)

export default component.exports